import CarouselV2 from './CarouselV2'

export default CarouselV2
